function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($component, $helpers, JSON, Object, String, errorMessage, from, isRangePicker, to) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'calendar-input': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'date-inputs': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("cohorts-date-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              value: from,
            }),
            "on": {
              blur: $helpers.blurredFrom,
              change: $helpers.changedFrom,
              focus: $helpers.focusedFrom,
            },
            "class": {
              'from-date-input': true
            },
          }));
          __jade_nodes = __jade_nodes.concat((isRangePicker) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'preposition': true
              },
            }, [__vjadeSafeCode($component.getAttribute(`preposition`) || `to`)]));
            __jade_nodes = __jade_nodes.concat(h("cohorts-date-input", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'error-message': errorMessage,
                value: to,
              }),
              "on": {
                blur: $helpers.blurredTo,
                change: $helpers.changedTo,
                focus: $helpers.focusedTo,
              },
              "class": {
                'to-date-input': true
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'calendars': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-calendar", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.getCalendarAttrs()),
            "on": {
              draw: $helpers.onDraw,
              selectDate: $helpers.selectedDate,
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "errorMessage" in locals ? locals.errorMessage : typeof errorMessage !== "undefined" ? errorMessage : undefined, "from" in locals ? locals.from : typeof from !== "undefined" ? from : undefined, "isRangePicker" in locals ? locals.isRangePicker : typeof isRangePicker !== "undefined" ? isRangePicker : undefined, "to" in locals ? locals.to : typeof to !== "undefined" ? to : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;